<template>
  <van-nav-bar
    v-if="!isPC"
    :title="title"
    left-arrow
    :right-text="backText"
    @click-left="onClickLeft"
    @click-right="onClickRight"
  />
  <van-nav-bar v-else :title="title" />
</template>
<script setup>
import { useRouter, useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useGarageStore } from '@/store/garage'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const garageStore = useGarageStore()
const backText = computed(() => route.path === '/garage' ? '' : t('message.garage.back'))

const isPC = computed(() => {
  return garageStore.client === 'pc'
})
defineProps({
  title: {
    type: String,
    default: ''
  }
})

const onClickLeft = () => {
  if (route.path === '/garage') {
    window.parent.postMessage({ type: 'back' }, '*')
  } else {
    router.back()
  }
}

const onClickRight = () => {
  console.log('click-right')
  router.push('/garage')
}
</script>
<style lang="scss"></style>
